import api from "./api";

export const animeType = {
  upcoming: "upcoming",
  popular: "popular",
  top_rated: "top_rated",
  top: "top",
  all: "",
};

export const tvType = {
  popular: "popular",
  top_rated: "top_rated",
  on_the_air: "on_the_air",
};

const animeApi = {
  getAnimeList: (type) => {
    const url = type === "top" ? animeType[type] + "/anime" : "/watch/episodes";
    return api.get(url);
  },
  getTopAnimeList: (type) => {
    const url = animeType[type] + "/anime";
    return api.get(url);
  },
};

export default animeApi;
